import React, { useEffect, useState } from "react";
import { Modal, Input, Select, Button, Form, notification } from "antd";
import { useStoreUpdaterWithAPI } from "../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../Common/APIConstants";
import { useNavigate, useLocation } from "react-router-dom";
import PopupUI from "../Elements/PopupUI";
import { CONFIGURATION_GROUP, CONFIGURATION_GROUPS, CONFIGURATION_STEAM_GROUP, CONFIGURATION_WATER_GROUP } from "../../Common/Constants";
import { useSelector } from "react-redux";

const GroupPopupContent = ({
  onClose,
  isAdd,
  isUpdate,
  fetchFlowGroupList, 
  updateRecord,
  flowGroupList,
  form,
}) => {
  const { makeRequest } = useStoreUpdaterWithAPI();
  const location = useLocation();

  const [groupModuleList, setGroupModuleList] = useState([]);
  const [reportStatusList, setReportStatusList] = useState([]);
  const [addFormData, setAddFormData] = useState({});
  const [updateFormData, setUpdateFormData] = useState({
    GroupID: "",
    GroupName: "",
    GroupModule: "",
    ReportStatus: "",
  });

  console.log(updateRecord);
  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: APIConstants.GET_APPLICATION_MODULE_DETAILS,
    }).then((res) => {
      setGroupModuleList(res);
      // console.log(res)
    });

    makeRequest({
      type: APIConstants.GET,
      url: APIConstants.GET_REPORT_STATUS_MASTER_DETAILS,
    }).then((res) => {
      setReportStatusList(res);
      // console.log(res)
    });
  }, []);

  useEffect(() => {
    if (isUpdate && updateRecord) {
      console.log("updateRecord:", updateRecord);

      const initialData = {
        GroupID: updateRecord?.groupID ? Number(updateRecord.groupID) : "",
        GroupName: updateRecord?.groupName || "",
        GroupModule: updateRecord?.groupModule
          ? Number(updateRecord.groupModule)
          : "",
        ReportStatus: updateRecord?.reportStatus
          ? Number(updateRecord.reportStatus)
          : "",
      };
      setUpdateFormData(initialData);
      // console.log("initialData:", initialData);
      form.setFieldsValue(initialData);
    }
  }, [isUpdate, updateRecord, form]);

  // useEffect(() => {
  //   // console.log("updateFormData:", updateFormData);
  // }, [updateFormData]);

  const handleClear = () => {
    form.resetFields();
  };

  const handleNotification = (msg) => {
    notification.open({
      message: `${msg}`,
    });
  };

  useEffect(() => {
    if (isAdd) {
      form.resetFields();
    }
  }, [isAdd, form]);

  const handleAddFormChange = (changedValues, allValues) => {
    setAddFormData(allValues);
  };

  const handleAddFormSubmit = async () => {
    try {
      const formData = {
        groupName: addFormData.GroupName1,
        groupModule: addFormData.GroupModule1,
        reportStatus: addFormData.ReportStatus1,
      };

      const isDuplicateAdd = flowGroupList.some(
        (item) =>
          item.groupName === formData.groupName &&
          item.groupModule === formData.groupModule
      );

      if (isDuplicateAdd) {
        notification.warning({
          message: "Warning",
          description: "Group with the same name and  module already exists.",
        });
        return;
      }

      await makeRequest({
        type: APIConstants.POST,
        url: APIConstants.INSERT_FLOW_GROUP_DETAILS,
        body: formData,
      });

      fetchFlowGroupList();
      handleNotification("Successfully Saved");
      handleClear();
      onClose();
    } catch (err) {
      console.error(err);
    }
  };

  const handleUpdateFormChange = (changedValues, allValues) => {
    setUpdateFormData((prev) => ({
      ...prev,
      ...allValues,
    }));
  };

  const handleUpdateFormSubmit = async () => {
    try {
      const formData = {
        groupID: updateFormData.GroupID,
        groupName: updateFormData.GroupName,
        groupModule: updateFormData.GroupModule,
        reportStatus: updateFormData.ReportStatus,
      };

      const isDuplicateUpdate = flowGroupList.some(
        (item) =>
          item.groupName === formData.groupName &&
          item.groupModule === formData.groupModule
      );

      if (isDuplicateUpdate) {
        notification.warning({
          message: "Warning",
          description: "Group with the same name and  module already exists.",
        });
        return;
      }

      // console.log(formData)
      await makeRequest({
        type: APIConstants.PUT,
        url: APIConstants.UPDATE_FLOW_GROUP_DETAILS,
        body: formData,
      });

      fetchFlowGroupList();
      handleNotification("Successfully Updated");
      handleClear();
      onClose();
    } catch (err) {
      console.error(err);
    }
  };

  const modeselect = useSelector((state) => state.darkMode);

  const { isdarkMode } = modeselect;

  return (
    <>
      {isAdd ? (
        <Form
          form={form}
          onFinish={handleAddFormSubmit}
          name="add-group-form"
          className="font-bold w-[350px]"
          labelCol={{ span: 8 }}
          layout="horizontal"
          onValuesChange={handleAddFormChange}
          initialValues={{}}
        >
          <Form.Item
            label="Grouping Name"
            name="GroupName1"
            rules={[{ required: true, message: "Please enter group name" }]}
          >
            <Input className="group-input"/>
          </Form.Item>

          <Form.Item
            label="Grouping ID"
            name="GroupName1"
            rules={[{ required: true, message: "Please enter group name" }]}
          >
            <Input className="group-input"/>
          </Form.Item>
          <Form.Item
            label="Group Module"
            name="GroupModule1"
            rules={[{ required: true, message: "Please select group module" }]}
          >
            <Select  className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} `}
            dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}>
              {groupModuleList?.map((item) => (
                <Select.Option
                  key={item?.moduleID}
                  value={item?.moduleID}
                 
                >
                  {/* {item?.moduleName} */}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Report Status"
            name="ReportStatus1"
            rules={[{ required: true, message: "Please select report status" }]}
          >
            <Select
             className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}  `}
            dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}>
              {reportStatusList?.map((item) => (
                <Select.Option
                  key={item?.reportStatusID}
                  value={item?.reportStatusID}
                >
                  {/* {item?.reportStatusName === "Yes" ? "Allow" : "Not Allow"} */}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item className="flex justify-end">
            <Button
              htmlType="submit"
              className="blue-btn mr-2"
            >
              Save
            </Button>
            <Button
              className="blue-btn"
              onClick={handleClear}
            >
              Clear
            </Button>
          </Form.Item>
        </Form>
      ) : (
        <Form
          form={form}
          onFinish={handleUpdateFormSubmit}
          name="update-group-form"
          className="font-bold w-[350px]"
          labelCol={{ span: 8 }}
          layout="horizontal"
          onValuesChange={handleUpdateFormChange}
          initialValues={updateFormData}
        >
          <Form.Item
            label="Grouping Name"
            name="GroupName"
            rules={[{ required: true, message: "Please enter group name" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Grouping ID"
            name="GroupName"
            rules={[{ required: true, message: "Please enter group name" }]}
          >
            <Input />
          </Form.Item>

          {/* <Form.Item
            label="Group Module"
            name="GroupModule"
            rules={[{ required: true, message: "Please select group module" }]}
          >
            <Select 
            className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}  `} 
            dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}>
              {groupModuleList?.map((item) => (
                <Select.Option
                  key={item?.moduleID}
                  value={item?.moduleID}
                >
                  {item?.moduleName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Report Status"
            name="ReportStatus"
            rules={[{ required: true, message: "Please select report status" }]}
          >
            <Select 
             className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}  `}
            dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}>
              {reportStatusList?.map((item) => (
                <Select.Option
                  key={item?.reportStatusID}
                  value={item?.reportStatusID}
                >
                  {item?.reportStatusName === "Yes" ? "Allow" : "Not Allow"}
                </Select.Option>
              ))}
            </Select>
          </Form.Item> */}
          <Form.Item className="flex justify-end">
            <Button
              htmlType="submit"
              className="blue-btn mr-2"
            >
              Update
            </Button>
            <Button
              className="blue-btn"
              onClick={handleClear}
            >
              Clear
            </Button>
          </Form.Item>
        </Form>
      )}
    </>
  );
};

const GroupPopup = ({
  isAdd,
  setIsAdd,
  isUpdate,
  setIsUpdate,
  fetchFlowGroupList,
  updateRecord,
  flowGroupList,
  title,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();

  const handlePopupState = (path) => {
    if (path.includes(`${CONFIGURATION_GROUP}/group-add-popup`)) {
      setIsAdd(true);
      setIsUpdate(false);
      form.resetFields();
    } else if(path.includes(`${CONFIGURATION_STEAM_GROUP}/group-add-popup`)) {
      setIsAdd(true);
      setIsUpdate(false);
      form.resetFields();
    }  else if(path.includes(`${CONFIGURATION_WATER_GROUP}/group-add-popup`)) {
      setIsAdd(true);
      setIsUpdate(false);
      form.resetFields();
    } else if (path.includes(`${CONFIGURATION_GROUP}/group-update-popup`)) {
      setIsUpdate(true);
      setIsAdd(false);
    } else if(path.includes(`${CONFIGURATION_STEAM_GROUP}/group-update-popup`)){
      setIsAdd(false);
      setIsUpdate(false);
    } else if(path.includes(`${CONFIGURATION_WATER_GROUP}/group-update-popup`)){
      setIsAdd(false);
      setIsUpdate(false);
    } 
  };


  useEffect(() => {
    handlePopupState(location.pathname);
    console.log(location.pathname)
  }, [location.pathname, form]);

  

  const handleClose = () => {
    setIsAdd(false);
    setIsUpdate(false);

    // Get the current path
    const currentPath = location.pathname;

    // Determine the base path based on the current path
    if (currentPath.includes(`${CONFIGURATION_GROUP}/group-add-popup`)) {
      navigate(CONFIGURATION_GROUP);
    } else if (currentPath.includes(`${CONFIGURATION_STEAM_GROUP}/group-add-popup`)) {
      navigate(CONFIGURATION_STEAM_GROUP);
    } else if (currentPath.includes(`${CONFIGURATION_WATER_GROUP}/group-add-popup`)) {
      navigate(CONFIGURATION_WATER_GROUP);
    }

    // Reset the form fields
    form.resetFields();
  };



  return (
    <>
      {updateRecord && (isUpdate || isAdd) ? (
        <PopupUI
       
          popupContent={
            <GroupPopupContent
              onClose={handleClose}
              isAdd={isAdd}
              isUpdate={isUpdate}
              fetchFlowGroupList={fetchFlowGroupList}
              updateRecord={updateRecord}
              flowGroupList={flowGroupList}
              form={form}
             title={title}
              hasModal={true}
            />
          }
          key={updateRecord?.groupID}
          isAdd={isAdd}
          setIsAdd={setIsAdd}
          isUpdate={isUpdate}
          setIsUpdate={setIsUpdate}
          handleClose={handleClose}
          updateRecord={updateRecord}
          flowGroupList={flowGroupList}
          isOpen={isUpdate || isAdd}
          hasModal={true}
          title={title}
        />
      ) : null}
    </>
  );
};

export default GroupPopup;
